export default __webpack_public_path__ + "static/media/schedularLeft.061f857b.svg";